@if (isLoading) {
  <app-st-loader-svg [width]="width" [height]="height" class="loader-svg"></app-st-loader-svg>
}
@if (src) {
  <img
    [ngSrc]="src"
    [width]="width"
    [height]="height"
    [alt]="alt"
    [title]="title"
    [style.display]="isLoading ? 'none' : 'inline'"
    (load)="hideLoader($event)"
    priority
  />
}
